import React, { useState } from "react";
import EditOrAddPan from "../EditOrAddPanModal/EditOrAddPan";
import { useGetEmployeePANDetails } from "../../../queries/employeeQueries";
import { useSelector } from "react-redux";
import userRoleAuth from "../../../utils/userRoleAuth/userRoleAuth";
import userRoles from "../../../config/userRoles";

const PanInfo = ({ employee }) => {
  const [openModal, setOpenModel] = useState(false);
  const onOpenModal = () => setOpenModel(true);
  const onCloseModal = () => setOpenModel(false);
  const loggedInUser = useSelector((state) => state.user.auth);
  const isHr = userRoleAuth(loggedInUser, userRoles.HR);
  const isAdmin = userRoleAuth(loggedInUser, userRoles.TENANTADMIN);
  const isAdminOrHR = isHr || isAdmin;
  const { data: panData } = useGetEmployeePANDetails({
    employee_id: employee?.employee_id,
  });

  const panDetails = panData?.data?.[0] || {};

  return (
    <div className="bg-white px-8 py-6 rounded-md border border-gray-100 shadow-md shadow-[#F3F4F6] mt-6 mb-5">
      <div className="flex items-center justify-between pb-3">
        <div className="flex items-center gap-3">
          <img src="/images/basic-info-icon.svg" alt="" />
          <p className="text-base text-[#1F2937] font-semibold">
            Permanent Account Number (PAN)
          </p>
        </div>
        {isAdminOrHR && (
          <div className="cursor-pointer">
            <>
              <img
                src="/images/editicon.svg"
                alt=""
                onClick={() => onOpenModal()}
              />
              <EditOrAddPan
                openModal={openModal}
                onCloseModal={onCloseModal}
                employee={employee}
                panDetails={panDetails}
              />
            </>
          </div>
        )}
      </div>

      <div className="flex justify-between employee-info-card">
        <table className="border-0">
          <tbody>
            <tr>
              <td className="title">Name in PAN</td>
              <td className="data">{panDetails?.name_on_pan || "N/A"}</td>
            </tr>
            <tr>
              <td className="title">PAN</td>
              <td className="data">{panDetails?.pan_number || "N/A"}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PanInfo;
